/**
 * How an AI host connects to BuzzBit X — the commands every surface shows.
 *
 * The server's host table (server/src/mcp/hostConfigs.ts) is the source;
 * these are its snippets, copied once so the Studio card, the Claude settings
 * tabs and /docs/mcp cannot drift apart. The server's hostConfigs test fails
 * if a snippet here stops matching the table. Every one signs in with the
 * merchant's BuzzBit X account in the browser: no key, no header.
 */

export const MCP_ENDPOINT = 'https://api.buzzbitx.com/mcp';

export const CLAUDE_CODE_COMMANDS = `claude mcp add --transport http buzzbitx https://api.buzzbitx.com/mcp
claude mcp login buzzbitx`;

export const CODEX_COMMAND = 'codex mcp add buzzbitx --url https://api.buzzbitx.com/mcp';

export const CURSOR_MCP_JSON = `{
  "mcpServers": {
    "buzzbitx": {
      "url": "https://api.buzzbitx.com/mcp"
    }
  }
}`;
